import React, {useState, useContext, useEffect, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../Selects/SelectFilter';
import Spinner from '../../../components/Spinner';
import InputFilter from '../../Filters/InputFilter';
import TablePagination from '../../TablePagination';
import {Context} from '../../../Helpers/Auth';
import Datepicker from 'react-tailwindcss-datepicker';
import LoadingModal from '../../LoadingModal';
import {getDados, getNegocios, getNegocioPesquisa, getNegocioFiltros, getRepresentantes} from '../../../pages/requests';
import MultiSelect from '../../Selects/MultiSelectComponent';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import NotFound from '../../NotFound';
import axios from 'axios';
import moment from 'moment';
import PersonIcon from '@mui/icons-material/Person';
import {Collapse, initTE} from 'tw-elements';
import {toast} from 'react-toastify';
import {getStatusNegocio} from '../api';
import SelectFilter from '../../Selects/SelectComponentFilt';

function Listagem({
    onRowClick,
    setOpenTab,
    consulta,
    kanban,
    filtroEstado,
    filtroRep,
    filtroPotencial,

    setFiltroCategoria,
    filtroCategoria,
    setFiltroMarca,
    filtroMarca,
    setFiltroNacionalInternacional,
    filtroNacionalInternacional,
    setFiltroFamilia,
    filtroFamilia,
    setFiltroStatusDt,
    filtroStatusDt,
    setFiltroRep,
    filtroNome,
    filtroEtapa,
    filtroEmpresa,
    setFiltroEmpresa,
    filtroCodigo,
    setFiltroCodigo,
    filtroDt,
    filtroValor,
    setFiltroDt,
    setFiltroEtapa,
    setFiltroNome,
    setFiltroValor,
    etapas,
    responsaveis,

    setFiltroEstado,
    setFiltroPotencial,
}) {
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {t} = useTranslation();
    const [visibilidade, setVisibilidade] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const {acessos, isCard, openCards, formatarNumero} = useContext(Context);
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    const [visibilidade2, setVisibilidade2] = useState(true);
    const [semDados, setSemDados] = useState(false);
    const [sorting, setSorting] = useState({field: '', order: ''});
    const [totalProdutos, setTotalProdutos] = useState(0);
    const [negocios, setNegocios] = useState([]);
    const [estados, setEstados] = useState([]);

    const [probabilidadeFiltros, setProbabilidadeFiltros] = useState([]);
    const [industriaFiltros, setIndustriaFiltros] = useState([]);
    const [search, setSearch] = useState('');
    const [etapaE, setEtapaE] = useState('');
    const [probabilidadeE, setProbabilidadeE] = useState('');
    const [responsavelE, setResponsavelE] = useState('');
    const [industriaE, setIndustriaE] = useState('');

    const [loading, setLoading] = useState(true);

    const [isMobile, setIsMobile] = useState(false);

    initTE({Collapse});

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    const ITEMS_PER_PAGE = 15;

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleRowClick = dados => {
        //setEditarNegocio(true);
        onRowClick(dados);

        setOpenTab(3);
    };

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

        setNegocios([]);
        setLoading(true);
        window.scrollTo(0, 0);
        debugger;
        getNegocios(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            kanban,
            consulta,
            filtroEstado?.value ?? '',
            filtroRep,
            filtroPotencial?.value ?? 0,
            filtroNome,
            filtroEtapa,
            filtroEmpresa,
            filtroDt.startDate ?? '',
            filtroDt.endDate ?? '',

            filtroValor,
            filtroCodigo,
            filtroCategoria?.value ?? '',
            filtroMarca?.value ?? '',
            filtroNacionalInternacional?.value ?? '',
            filtroFamilia?.value ?? '',
            filtroStatusDt?.startDate ?? '',
            filtroStatusDt?.endDate ?? '',
        )
            .then(res => {
                if (res.data.success) {
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                        setVisibilidade2(false);
                    }
                    setNegocios(res.data.negocios);
                    setTotalProdutos(res.data.totalprodutos);
                } else {
                    res.data.error_object.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [
        currentPage,
        filtroNome,
        filtroRep,
        filtroEtapa,
        filtroEmpresa,
        filtroDt,
        filtroStatusDt,
        filtroValor,
        filtroCodigo,
        filtroPotencial,
        filtroEstado,
        filtroCategoria,
        filtroMarca,
        filtroNacionalInternacional,
        filtroFamilia,
    ]);

    useEffect(() => {
        if (negocios.length != 0 && semDadosEstado == false && etapas != '' && responsaveis != '' /*&& probabilidadeFiltros != "" && industriaFiltros != ""*/) {
            setVisibilidade(false);
            setSemDados(false);
            setVisibilidade2(false);
        } else if (negocios.length == 0 && semDadosEstado == true) {
            setVisibilidade(false);
        }
    }, [negocios, etapas, responsaveis, probabilidadeFiltros, industriaFiltros]);

    const negociosDados = useMemo(() => {
        let negociosInfo = negocios;

        if (sorting.field) {
            const reversed = sorting.order === 'asc' ? 1 : -1;
            negociosInfo = negociosInfo.sort((a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field]));
        }

        return negociosInfo;
    }, [negocios, currentPage, sorting /*,search, etapaE, responsavelE, probabilidadeN, industriaN*/]);

    function showButton(params) {
        if (
            filtroEstado ||
            filtroRep.length != 0 ||
            filtroPotencial != 0 ||
            filtroCategoria ||
            filtroMarca ||
            filtroNacionalInternacional ||
            filtroFamilia ||
            filtroEtapa.length != 0 ||
            filtroEmpresa ||
            filtroCodigo ||
            filtroNome ||
            filtroDt.startDate ||
            filtroStatusDt.startDate ||
            filtroValor
        ) {
            return true;
        } else {
            return false;
        }
    }
    function limparFiltros() {
        setFiltroEstado(null);
        setFiltroStatusDt({startDate: null, endDate: null});
        setFiltroRep([]);
        setFiltroPotencial(0);
        setFiltroCategoria(null);
        setFiltroMarca(null);
        setFiltroNacionalInternacional(null);
        setFiltroFamilia(null);
        setFiltroEtapa([]);
        setFiltroEmpresa('');
        setFiltroCodigo('');
        setFiltroNome('');
        setFiltroDt({startDate: null, endDate: null});
        setFiltroValor(0);
    }

    useEffect(() => {
        if (negociosDados.length == 0 && loading == false) {
            setSemDados(true);
        } else {
            setSemDados(false);
        }
    }, [negociosDados]);

    useEffect(() => {
        getStatusNegocio(lang).then(res => {
            setEstados(res.data.status);
        });
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <div>
            {isMobile || isCard ? (
                <div>
                    {negociosDados?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row" onClick={() => handleRowClick(dados)}>
                                        {dados.num} - {dados.nome}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('etapa')}:</div> {dados.descricaoEtapa}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        {/* <div className="font-medium text-gray-400 mr-2">{t('representante')}: </div> {dados.responsavelNome} */}
                                        <div className="font-medium text-gray-400 mr-2">{t('representante')}: </div> {dados.responsavel.label}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('empresa')}: </div> {dados.empresa}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('dataCriacao')}: </div> {moment(dados.dataCriacao).format(FORMATO_DATA)}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('estado')}: </div> {dados.status.label}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('dataEstado')}: </div> {dados.dataFecho ? moment(dados.dataFecho).format(FORMATO_DATA) : '-'}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('valor')}: </div>{' '}
                                        <a href="#" className=" flex justify-end text-blue-600 dark:text-blue-500 font-medium  hover:underline">
                                            {/* {new Intl.NumberFormat('de-DE', {
                                                style: 'currency',
                                                currency: 'EUR',
                                            }).format(dados.valor)} */}
                                            {formatarNumero(dados.valor)} €
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}
                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            ) : (
                <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px] z-0">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    {t('codigo')}
                                    <InputFilter
                                        value={filtroCodigo}
                                        onSearch={value => {
                                            setFiltroCodigo(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('denominacao')}
                                    <InputFilter
                                        value={filtroNome}
                                        onSearch={value => {
                                            setFiltroNome(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    {t('etapa')}
                                    <MultiSelect
                                        options={etapas}
                                        value={filtroEtapa}
                                        onChange={e => {
                                            setFiltroEtapa(e);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    {t('representante')}
                                    <MultiSelect
                                        options={responsaveis}
                                        value={filtroRep ?? filtroRep.label}
                                        onChange={e => {
                                            setFiltroRep(e);
                                            setCurrentPage(1);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('empresa')}
                                    <InputFilter
                                        value={filtroEmpresa}
                                        onSearch={value => {
                                            debugger;
                                            setFiltroEmpresa(value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </th>
                                <th scope="col" className=" py-3 w-64">
                                    {t('dataCriacao')}
                                    <Datepicker
                                        displayFormat={FORMATO_DATA}
                                        useRange={false}
                                        // asSingle={true}
                                        value={filtroDt}
                                        onChange={newValue => {
                                            setFiltroDt(newValue);
                                            setCurrentPage(1);
                                        }}
                                        inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>
                                <th scope="col" className="px-3 py-3">
                                    {t('estado')}
                                    <SelectFilter
                                        options={estados}
                                        value={filtroEstado}
                                        onChange={e => {
                                            setFiltroEstado(e);
                                            setCurrentPage(1);
                                        }}
                                        noOptionsMessage={t('semopcoes')}
                                        placeholder={t('filtro')}
                                    />
                                </th>
                                <th scope="col" className="px-2 py-3 w-64">
                                    {t('dataFecho')}
                                    <Datepicker
                                        displayFormat={FORMATO_DATA}
                                        useRange={false}
                                        // asSingle={true}
                                        value={filtroStatusDt}
                                        onChange={newValue => {
                                            setFiltroStatusDt(newValue);
                                            setCurrentPage(1);
                                        }}
                                        inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('valor')}
                                    <div className="flex flex-row ">
                                        <InputFilter
                                            value={filtroValor}
                                            onSearch={value => {
                                                if (!isNaN(value)) {
                                                    setFiltroValor(Number(value));
                                                    setCurrentPage(1);
                                                }
                                            }}
                                        />
                                        {showButton() && (
                                            <button
                                                onClick={limparFiltros}
                                                type="button"
                                                className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                <FilterAltOffIcon />
                                            </button>
                                        )}
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {negociosDados.map(dados => (
                                <>
                                    {/* {setTotalProdutos(dados)} */}
                                    <tr
                                        className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400"
                                        onClick={() => handleRowClick(dados)}>
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.num}
                                        </th>
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.nome}
                                        </th>
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.descricaoEtapa}
                                        </th>
                                        <td className="px-6 py-1">{dados.responsavel.label}</td>
                                        <td className="px-6 py-1 text-blue-600 dark:text-blue-500">{dados.empresa}</td>
                                        <td className=" py-1">{moment(dados.dataCriacao).format(FORMATO_DATA)}</td>
                                        <td className="px-2 py-1">{dados.status.label}</td>
                                        <td className="px-6 py-1">{dados.dataFecho ? moment(dados.dataFecho).format(FORMATO_DATA) : '-'}</td>
                                        <td className="px-6 py-1">
                                            <a href="#" className=" flex justify-end text-blue-600 dark:text-blue-500 font-medium  hover:underline">
                                                {/* {new Intl.NumberFormat('de-DE', {
                                                    style: 'currency',
                                                    currency: 'EUR',
                                                }).format(dados.valor)} */}
                                                {formatarNumero(dados.valor)} €
                                            </a>
                                        </td>
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                    {semDados && !loading && <NotFound frase={t('semRegistos')} />}
                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        {totalProdutos != 0 && <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                    </nav>
                </div>
            )}
        </div>
    );
}

export default Listagem;
